module.exports = __webpack_public_path__ + "img/P42-zh.09f6ad55.png";